import React from 'react';

export default function Loading({ additionalData }: {
  additionalData: {
    hitClassesLoading?: string;
    itemCount?: number;
  };
}) {
  const { hitClassesLoading, itemCount } = additionalData;
  return (
    <>
      {Array.from({ length: itemCount ?? 9 }, (_, index) => (
        <div key={index} className={`${hitClassesLoading ?? 'w-full'} flex aspect-square overflow-hidden`}>
          <div
            className="group/card px-10 pb-8 size-full relative flex flex-col justify-between no-underline transition-all overflow-hidden rounded-2xl border border-dark/10 bg-blue-100 animate-pulse"
          >
            <div className="px-4 py-1.5 bg-light rounded-bl-md rounded-br-md border-l border-r border-b border-dark/10 h-8.25 w-18.25"/>
            <div className="flex flex-col gap-2">
              <div className="bg-light w-full h-10.75" />
              <div className="bg-light w-full h-16" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
